import { createAppKit } from '@reown/appkit/react'
import { WagmiAdapter } from '@reown/appkit-adapter-wagmi'
import { arbitrum, mainnet, polygon, base, optimism } from '@reown/appkit/networks'
import { defineChain } from '@reown/appkit/networks'

// Reown Project ID (shared with DAGARMY for cross-platform SSO)
const projectId = (process.env.REACT_APP_REOWN_PROJECT_ID || 'ba3751e293e717d7fd71426e6c862e79').trim()

// DAGGPT metadata
const metadata = {
  name: 'DAGGPT',
  description: 'AI-Powered Creative Platform - Chat, Image, Video & Music Generation',
  url: 'https://daggpt.network',
  icons: ['https://daggpt.network/DAGGPT-01.jpg']
}

// Define Custom DAG Chain
const dagchain = defineChain({
  id: 707070,
  name: 'DAG Chain',
  network: 'dagchain',
  nativeCurrency: {
    decimals: 18,
    name: 'DAG Coin',
    symbol: 'DGCC',
  },
  rpcUrls: {
    default: { http: ['https://rpc.dagchain.network'] },
    public: { http: ['https://rpc.dagchain.network'] },
  },
  blockExplorers: {
    default: { name: 'DAG Explorer', url: 'https://explorer.dagchain.network' },
  },
})

// Blockchain networks (included DAG Chain for deposits)
const networks = [dagchain, mainnet, arbitrum, polygon, base, optimism]

// Create Wagmi Adapter
export const wagmiAdapter = new WagmiAdapter({
  networks,
  projectId,
  ssr: false // Create React App is CSR only
})

// Create AppKit modal with SSO-only configuration
export const modal = createAppKit({
  adapters: [wagmiAdapter],
  networks,
  defaultNetwork: dagchain,
  projectId,
  metadata,
  features: {
    analytics: true,
    email: false,
    socials: [],
    emailShowWallets: false,
    allWallets: true,
    collapseWallets: false,
    connectMethodsOrder: ['wallet'],
    onramp: false,
    swaps: false,
    smartSessions: false
  },
  enableWallets: true, // Enable Web3 Wallets for bridging
  themeMode: 'light',
  themeVariables: {
    '--w3m-font-family': 'Inter, sans-serif',
    '--w3m-accent': '#8B5CF6', // DAGGPT purple
    '--w3m-border-radius-master': '12px',
    '--w3m-color-mix': '#FFFFFF',
    '--w3m-color-mix-strength': 10
  }
})

export const config = wagmiAdapter.wagmiConfig

// Make modal available globally for client components
if (typeof window !== 'undefined') {
  window.modal = modal
}
